// extracted by mini-css-extract-plugin
export var progressContainer = "_fo-0";